import React from 'react';
import PropTypes from 'prop-types';
import { useRequestData, usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { trackEvent } from 'ddc-track-event';
import { publishVehicleData } from '../../../utilities/vehicleTracking';

const VehicleTitle = ({
	isTabbedLayout,
	title,
	link,
	vehicleId,
	condition
}) => {
	const { windowId, widgetName, deviceType } = useRequestData();
	const { showPricingSummary } = usePrefs();
	const formatTitle = ([subtitle, maintitle]) => {
		const formattedTitle = (
			<React.Fragment>
				<span className="ddc-font-size-small">{subtitle}</span>
				{maintitle}
			</React.Fragment>
		);
		return typeof maintitle === 'undefined' ? subtitle : formattedTitle;
	};

	const conditionClassName = condition
		? `inv-type-${condition}`.toLowerCase().replace(/ /g, '-')
		: '';

	return (
		<h2
			data-style-editor-price={
				!!(isTabbedLayout && showPricingSummary === 'true')
			}
			className={setClassNames([
				'vehicle-card-title',
				'mt-0',
				'd-flex',
				'justify-content-between',
				'align-items-end',
				isTabbedLayout && deviceType !== 'MOBILE' ? 'h3' : null,
				conditionClassName
			])}
		>
			<a
				href={link}
				onClick={() => {
					trackEvent(widgetName, windowId, {
						element: 'Vehicle title',
						result: 'Navigated to VDP'
					});
					publishVehicleData(vehicleId);
				}}
			>
				{formatTitle(title)}
			</a>
			{/* Portal for Pricing Summary */}
			{isTabbedLayout && showPricingSummary === 'true' && (
				<span
					className="text-right portal-price"
					id={`${vehicleId}_priceTitle`}
					data-style-editor-id={`srp-${conditionClassName}-portal-price-value`}
					data-style-editor-text={`.srp .vehicle-card-title.${conditionClassName} .portal-price`}
				/>
			)}
		</h2>
	);
};

VehicleTitle.propTypes = {
	isTabbedLayout: PropTypes.bool.isRequired,
	title: PropTypes.arrayOf(PropTypes.string).isRequired,
	link: PropTypes.string.isRequired,
	vehicleId: PropTypes.string.isRequired,
	condition: PropTypes.string.isRequired
};

export default VehicleTitle;
